<template>
    <div class="box" style="padding:8px">
        <div v-if="images.length > 0">
            <div class="notification is-danger limitPopup" v-if="maxReached">
                <button class="delete" v-on:click="closePopup()"></button>
                Maximum image limit reached.<br>
                remove images to add more
            </div>
            <div class="columns is-multiline is-mobile">
                <div v-for="(image, index) in images" class="column is-4 ">
                    
                    <div class="box xBox">
                        <span class="icon x" v-on:click="removeImage(index)">
                            <i class="fas fa-close"></i>
                        </span>
                        <span class="loader" v-if="!image" ></span>
                    </div>
                    <img
                    :src="getImageUrl(image)"
                    class="image-preview"
                    alt="Wait a moment..."
                    v-on:click="prepareBigImages(index)"
                    
                    >
                    
                </div>
                </div>
                <bigImage
                v-if="showBigPreview"
                @close="closeBigPreview"
                v-bind:images="images"
                v-bind:initialIndex="indexBigPreview"></bigImage>
            </div>
            <div v-else="v-else" style="height: 6vh;">
                <p style="margin-top: 3vh; margin-left: 5%;">
                    <b>Your Images will appear here...</b>
                </p>
            </div>
        </div>
        
    </template>
    
    <script>
    import bigImage from './bulma_pictureviewer.vue';
    import {HeifDecoder} from 'libheif-js';
    
    export default {
        components: {
            bigImage
        },
        watch: {
            images: {
                immediate: true,
                deep: true,
                async handler(newImages) {
                    console.log("watching")
                    if(newImages.length > this.imgLimit){
                        this.maxReached = true;
                        this.$emit('exceeded-limit', { newPictures:  this.images.slice(0, this.imgLimit)});

                        return true;
                    }
                    for (const url of newImages) {
                        if (!this.decodedImages[url] && !this.decodingQueue.has(url)) {
                            
                            await this.processHeicImage(url);
                            
                        }
                    }
                    
                    
                    
                }
            },
            // images: {
            //     handler(newVal, oldVal) {
                    
                    
                
            //     }
            // },
        },
        props: {
            images: [],
            imgLimit: Number
        },
        data() {
            return {maxReached: false, 
                showBigPreview: false, 
                indexBigPreview: -1, 
                decodedImages: {}, 
                decodingQueue: new Set()
            }
        },
        methods: {
            closePopup() {
                this.maxReached = false;
            },
            removeImage(index) {
                //emit to imagesmanager
                this.$emit('remove-picture', {index: index});
            },
            prepareBigImages(index) {
                this.indexBigPreview = index;
                this.showBigPreview = true;
            },
            closeBigPreview() {
                this.showBigPreview = false;
            },
            async processHeicImage(url) {
                // this.$set(this.decodedImages, url, false);
                try {
                    this.decodingQueue.add(url);
                    
                    const response = await fetch(url);
                    const blob = await response.blob();
                    
                    if (this.isHeic(blob, url)) {
                        const imageUrl = await this.decodeHeic(blob);
                        this.$set(this.decodedImages, url, imageUrl);
                    } else {
                        this.$set(this.decodedImages, url, URL.createObjectURL(blob));
                    }
                } catch (error) {
                    console.error('HEIC decoding error:', error);
                    this.$set(this.decodedImages, url, url); // Fallback
                } finally {
                    this.decodingQueue.delete(url);
                }
            },
            
            isHeic(blob, url) {
                return blob.type.includes('heic') || blob.type.includes('heif') || url.toLowerCase().endsWith('.heic') || url.toLowerCase().endsWith('.heif');
            },
            
            async decodeHeic(blob) {
                const arrayBuffer = await blob.arrayBuffer();
                const decoder = new HeifDecoder();
                const data = new Uint8Array(arrayBuffer);
                
                const image = decoder.decode(data)[0];
                if (!image) 
                throw new Error('No HEIC image found');
                
                const width = image.get_width();
                const height = image.get_height();
                
                // Creazione canvas per il rendering
                const canvas = document.createElement('canvas');
                canvas.width = width;
                canvas.height = height;
                const ctx = canvas.getContext('2d');
                
                // Decodifica e rendering
                const imageData = await new Promise((resolve, reject) => {
                    image.display({
                        data: new Uint8ClampedArray(width * height * 4),
                        width,
                        height
                    }, (displayData) => {
                        if (!displayData) 
                        reject(new Error('HEIC decoding failed'));
                        resolve(displayData);
                    });
                });
                
                // Disegna sul canvas
                const imgData = new ImageData(imageData.data, width, height);
                ctx.putImageData(imgData, 0, 0);
                
                // Converti in URL
                return new Promise((resolve) => {
                    canvas.toBlob(blob => {
                        resolve(URL.createObjectURL(blob));
                    }, 'image/jpeg', 0.85);
                });
            },
            getImageUrl(url) {
                return this.decodedImages[url] || url;
            },
            
            // Cleanup degli URL creati
            beforeUnmount() {
                Object
                .values(this.decodedImages)
                .forEach(url => {
                    if (url.startsWith('blob:')) 
                    URL.revokeObjectURL(url);
                }
                );
            }
        }
    }
</script>
<style>
.xBox {
    border-radius: var(--bulma-box-radius) var(--bulma-box-radius) 0 0 !important;
    
    margin-bottom: 0 !important;
    padding-top: 2px !important;
    padding-bottom: 2px !important;
    
}
.x {
    margin-left: 75%;
    width: 30px;
    height: 30px;
    border: solid 1px rgb(201, 201, 201);
    border-radius: 100%;
}
.x:hover {
    /* margin-left: 90%; */
    width: 30px;
    height: 30px;
    border: solid 1px rgb(201, 201, 201);
    border-radius: 100%;
    transform: scale(1.05);
}
.limitPopup {
    position: fixed;
    top: 25px;
    right: 5%;
    min-width: 50%;
    z-index: 1000;
    /* opacity: 0.8; */
}
.image-preview {
    display: block;
    max-width: 100%;
    margin: 0 auto, 10px auto;
    border-radius: 0 0 var(--bulma-box-radius) var(--bulma-box-radius) !important;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    aspect-ratio: 1 / 0.75;
    object-fit: cover;
}

.loader {
    /* position: absolute;
    left:3vw; */
    z-index: 150;
    width: 15px;
    height: 15px;
    border: 5px solid rgba(156, 156, 156, 0.815);;
    border-bottom-color: transparent;
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
    }

    @keyframes rotation {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
} 
</style>